import { lazy } from "react";

export type { IEditNichesDialogProps } from "./types";
export { Roles } from "./types";

export const EditNichesDialog = lazy(() => import("./EditNichesDialog"));
